import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { ZahlkondListView } from './list-view/zahlkond.list-view';

export const zahlkondFieldOk: FieldOkConfig = {
  name: 'zahlkond',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlkond}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlkondListView,
        sort: {
          properties: [{ property: 'zahlkond', title: 'Code' }],
        },
      },
    },
  ],
};

export const zahlkondMultiselectFieldOk: FieldOkConfig = {
  name: 'zahlkond',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlkond}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlkondListView,
        sort: {
          properties: [{ property: 'zahlkond', title: 'Code' }],
        },
      },
    },
  ],
};

export const zahlkondQueryFieldOk: FieldOkConfig = {
  name: 'zahlkond',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlkond}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlkondListView,
        sort: {
          properties: [{ property: 'zahlkond', title: 'Code' }],
        },
      },
    },
  ],
};
